<template>
  <div class="w100 flexVC">
    <fullPage @leaveSlide="leaveSlide" ref="fullPage">
      <div slot="section" class="container">
        <home-first></home-first>
      </div>
      <div slot="section" class="container">
        <home-second :currentIndex="currentIndex"></home-second>
      </div>
      <div slot="section" class="container">
        <home-third :currentIndex="currentIndex" :lastIndex="lastIndex"
                    @scrollListener="scrollListener"></home-third>
      </div>
      <div slot="section" class="container">
        <home-fourth  :currentIndex="currentIndex"></home-fourth>
      </div>
      <div slot="section" class="container">
        <home-fifth  :currentIndex="currentIndex"></home-fifth>
      </div>
      <div slot="section" class="container">
        <home-sixth  :currentIndex="currentIndex"
                     @scrollListener="scrollListener"></home-sixth>
      </div>
    </fullPage>
  </div>
</template>

<script>
  import homeFirst from '@/page/home/components/homeFirst'
  import homeSecond from '@/page/home/components/HomeSecond'
  import homeThird from '@/page/home/components/HomeThird'
  import homeFourth from '@/page/home/components/HomeFourth'
  import homeFifth from '@/page/home/components/HomeFifth'
  import homeSixth from '@/page/home/components/HomeSixth'
  import fullPage from '@/components/fullPage'

  export default {
    name: "Home",
    data() {
      return {
        currentIndex: 0,
        lastIndex: 2,
      }
    },

    components: {
      homeFirst,
      homeSecond,
      homeThird,
      homeFourth,
      homeFifth,
      homeSixth,
      fullPage,
    },

    mounted() {
      // this.$refs.fullPage.api.setAllowScrolling(false)
    },

    methods: {
      leaveSlide(item) {
        this.currentIndex = item.currentIndex
        this.lastIndex = item.currentIndex
        if (item.currentIndex == 3 || item.currentIndex == 6) {
          this.$refs.fullPage.api.setAllowScrolling(false)
        }
      },
      scrollListener(e) {
        console.log('scrollListener----------', e)
        this.$refs.fullPage.api.setAllowScrolling(true)
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/home/Home.vue